export const CONSTANTS = Object.freeze({
  ROUTES: {
    LOGIN: '',
    LOADING: 'loading',
    NO_VALID_LOGIN: 'login-no-valido',
    CURRICULUM: {
      CURRICULUM_HOME: '',
      CURRICULUM_UPLOAD: 'curriculum-upload',
      CURRICULUM_UPLOAD_TITLE: 'Subir Currículum Vitae',
      CURRICULUM_SEARCH: 'curriculum-search',
      CURRICULUM_SEARCH_TITLE: 'Búsqueda de CV',
      CURRICULUM_EDIT: 'curriculum-edit',
      CURRICULUM_EDIT_TITLE: 'Edición de currículum',
      CURRICULUM_DETAIL: 'curriculum-detail',
      CURRICULUM_DETAIL_TITLE: 'Detalle de currículum',
      CURRICULUM_EDIT_PROFESSIONAL_INFO: 'curriculum-edit-professional-info',
      CURRICULUM_EDIT_PROFESSIONAL_INFO_TITLE: 'Edición de currículum',
      CURRICULUM_SUMMARY: 'curriculum-summary',
      CURRICULUM_SUMMARY_TITLE: 'Exportar Currículum Vitae',
      JOBOFFERS_SEARCH_BY_CV: 'job-offers-search-by-cv',
      JOBOFFERS_SEARCH_BY_CV_TITLE: 'Búsqueda de ofertas',
      JOBOFFERS_LIST: 'job-offers-list',
      JOBOFFERS_LIST_TITLE: 'Listado de ofertas',
    },
    JOBSEEKER: {
      JOBSEEKER_SEARCH: 'jobseeker-search',
      JOBSEEKER_SEARCH_TITLE: 'Búsqueda de candidatos',
      JOBSEEKER_SEARCH_JOBOFFERS: 'jobseeker-search-job-offers',
      JOBSEEKER_SEARCH_JOBOFFERS_TITLE: 'Búsqueda de oferta',
      JOBSEEKER_SEARCH_JOBOFFERS_FILTERS: 'jobseeker-search-job-offers-filters',
      JOBSEEKER_SEARCH_JOBOFFERS_FILTERS_TITLE: 'Filtros de oferta',
      JOBSEEKER_LIST: 'jobseeker-list',
      JOBSEEKER_LIST_TITLE: 'Resultados de candidatos',
    },
    JOBOFFERS: {
      JOBOFFERS_HOME: '',
      JOBOFFERS_HOME_TITLE: 'Gestión de Ofertas',
      JOBOFFERS_UPLOAD: 'job-offers-upload',
      JOBOFFERS_UPLOAD_TITLE: 'Subir oferta',
      JOBOFFERS_SEARCH: 'job-offers-search',
      JOBOFFERS_SEARCH_TITLE: 'Búsqueda de oferta',
      JOBOFFERS_EDIT: 'job-offers-edit',
      JOBOFFERS_EDIT_TITLE: 'Edición de oferta',
      JOBOFFERS_DETAIL: 'job-offers-detail',
      JOBOFFERS_DETAIL_TITLE: 'Detalle de oferta',
      JOBOFFERS_SUMMARY: 'job-offers-summary',
      JOBOFFERS_SUMMARY_TITLE: 'Guardado de oferta',
    },
    MANAGEMENT: {
      MANAGEMENT_HOME: '',
      MANAGEMENT_HOME_TITLE: 'Gestión',
      MANAGEMENT_USERS_HOME: 'users-search',
      MANAGEMENT_USERS_HOME_TITLE: 'Listado de usuarios',
      MANAGEMENT_USERS_EDIT: 'users-edit/:id',
      MANAGEMENT_USERS_EDIT_TITLE: 'Edición de usuario',
    },
  },
  STYLE: {
    COLORS: {
      BACKGROUNDS: {
        SUCCESS: 'bg-success-base',
        SUCCESS_LIGHT: 'bg-success-light',
        INFO: 'bg-info-base',
        INFO_LIGHT: 'bg-info-light',
        WARNING: 'bg-warning-base',
        WARNING_LIGHT: 'bg-warning-light',
        ALERT: 'bg-alert-base',
        ALERT_LIGHT: 'bg-alert-light',
      },
      FOREGROUNDS: {
        SUCCESS: 'text-success-base',
        INFO: 'text-info-base',
        WARNING: 'text-warning-base',
        ALERT: 'text-alert-base',
      },
      BORDERS: {
        SUCCESS: 'border-success-base',
        INFO: 'border-info-base',
        WARNING: 'border-warning-base',
        ALERT: 'border-alert-base',
      },
    },
    LINK: {
      CLASSES:
        'c-link hover:bg-primary-base hover:text-white truncate  focus:bg-warning-base focus:outline-none focus:shadow-outline-focus focus:text-black cursor-pointer',
    },
    PILL: {
      CLASSES: 'c-pill',
    },
    SQUARE: {
      CLASSES: 'inline-block w-base h-base mr-sm mt-1 lg:mt-0',
    },
    TEXT: {
      ELLIPSIS: 'truncate',
    },
    TABLE: {
      ADVANCED: {
        CLASSES_CELL_DROPDOWN_CLOSE: 'sticky right-0 w-60 max-h-20 relative bg-white',
        CLASSES_CELL_DROPDOWN_OPEN: 'sticky right-0 w-60 max-h-20 relative bg-white z-50',
      },
    },
    NOTIFICATION: {
      SUCCESS: 'c-notification c-notification--success',
      ALERT: 'c-notification c-notification--alert',
      INFO: 'c-notification c-notification--primary',
    },
  },
  MESSAGES: {
    BUTTONS: {
      SEND: 'Enviar',
      SEARCH: 'Buscar',
      CLEAN: 'Limpiar',
    }, 
    TEXT: {
      CURRICULUM: {
        SUMMARY: {
          DELETE_SUCCESS: 'Currículum vitae eliminado correctamente.', 
        },
      },
      JOBOFFERS: {
        TITLE: 'Gestión de ofertas',
        DESCRIPTION: 'Desde esta sección podrás subir nuevas ofertas de empleo para que nuestro sistema las conecte con los candidatos más adecuados según su perfil y experiencia. Además, podrás consultar cualquier oferta existente.',     
        SEARCH: {
          TITLE: 'Búsqueda de oferta', 
          DESCRIPTION: 'Encuentra cualquier oferta al instante usando su identificador y accede fácilmente a un listado posible de candidatos.'
        },
        SUMMARY: {
          TITLE: 'Búsqueda de oferta', 
          DESCRIPTION: 'Encuentra cualquier oferta al instante usando su identificador y accede fácilmente a un listado posible de candidatos.',
          SAVE_SUCCESS: 'Oferta de empleo guardada correctamente.',
          DELETE_SUCCESS: 'Oferta de empleo eliminada correctamente.'
        },
      },
      MANAGEMENT: {
          USERS: {
            EDIT_SUCCESS: 'Usuario editado correctamente.', 
            CREATE_SUCCESS: 'Usuario creado correctamente.', 
            DELETE_SUCCESS: 'Usuario eliminado correctamente.', 
          },
        },
    },
    CARDS: {
      JOBOFFERS:{
        UPLOAD_TITLE: 'Carga de oferta',
        UPLOAD_TEXT: 'Sube una oferta de empleo y nuestro sistema se encargará de encontrar posibles candidatos.',
        SEARCH_TITLE: 'Búsqueda de oferta',
        SEARCH_TEXT: 'Encuentra ofertas de empleo específicas a partir de un identificador y un código de proveedor.',
      }   
    },
    LOADING: {
      PROCESSING_CV: 'La Inteligencia Artificial está procesando el CV y preparando los datos...',
      PROCESSING_JOBOFFERS: 'La Inteligencia Artificial está procesando la oferta y preparando los datos...',
      DEDUCING_INFO: 'La Inteligencia Artificial está extrayendo la información de el CV...',
      SAVING_INFO: 'Guardando currículum vitae...',
      SAVING_JOBOFFERS: 'Guardando oferta de empleo...',
      SEARCHING_CV: 'Buscando currículum vitae...',
      SEARCHING_JOBOFFERS: 'Buscando oferta de empleo...',
      SEARCHING_JOBSEEKERS: 'Buscando candidatos según tu descripción, esto puede tardar unos segundos...',
      SEARCHING_JOBOFFERS_BY_CV: 'Buscando ofertas de empleo para el candidato...',
      SEARCHING_JOBSEEKERS_JOBOFFERS: 'Buscando candidatos que se ajusten a la oferta de empleo. Esto puede tardar unos segundos...',
    },
    ERROR: {
      VALIDATION_MANDATORY_FORM: 'Por favor, completa o revisa los siguientes campos antes de continuar:',
      PROCESSING_CV_STEP1: 'Error al deducir información del CV, por favor, vuelva a intentarlo.',
      PROCESSING_CV_STEP2: 'Error al guardar los cambios, por favor, vuelva a intentarlo.',
      SEARCH_JOBSEEKER_ERROR: 'No se han podido recuperar candidatos para los parámetros de búsqueda introducidos.',
      SEARCH_JOBSEEKER_TIMEOUT: 'La búsqueda de candidatos ha tardado demasiado en completarse. Intenta añadir más detalle en los filtros para reducir el número de resultados.'
    }
  }
});
